export default "__VITE_ASSET__Dt0GnX_v__"